import { render } from "./CollectionListView.vue?vue&type=template&id=83fdb684"
import script from "./CollectionListView.vue?vue&type=script&lang=js"
export * from "./CollectionListView.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__